import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import PendingScreenPage from "./pages/PendingScreenPage";
import CadastrarFuncionarioPage from "./pages/CadastrarFuncionarioPage";
import ListaFuncionariosPage from "./pages/ListaFuncionariosPage";
import EditarFuncionarioPage from "./pages/EditarFuncionarioPage";
import CadastrarEstudantePage from "./pages/CadastrarEstudantePage";
import ListaEstudantesPage from "./pages/ListaEstudantesPage";
import EditarEstudantePage from "./pages/EditarEstudantePage";
import NotificacoesEstudantesPage from "./pages/NotificacoesEstudantesPage";
import ListaPropinasPage from "./pages/ListaPropinasPage";
import ConfirmarPagamentoPage from "./pages/ConfirmarPagamentoPage";
import AmortizarPagamentoPage from "./pages/AmortizarPagamentoPage";
import PdfPreviewPage from "./pages/PdfPreviewPage";
import FacturacaoAgregadaPage from "./pages/FacturacaoAgregadaPage";
import PresencasEstudantesPage from "./pages/PresencasEstudantesPage";
import ListaPresencasColaboradoresPage from "./pages/ListaPresencasColaboradoresPage";
import CriarTurmaPage from "./pages/CriarTurmaPage";
import ListaTurmasPage from "./pages/ListaTurmasPage";
import AlocarEstudantesPage from "./pages/AlocarEstudantesPage";
import DisciplinasPage from "./pages/DisciplinasPage";
import CadastrarDisciplinaPage from "./pages/CadastrarDisciplinaPage";
import AvaliacoesPage from "./pages/AvaliacoesPage";
import CadastrarAvaliacaoPage from "./pages/CadastrarAvaliacaoPage";
import LancamentoNotasPage from "./pages/LancamentoNotasPage";
import ListaNotasPage from "./pages/ListaNotasPage";
import PautaVisualizarPage from "./pages/PautaVisualizarPage";
import PautasPage from "./pages/PautasPage";
import BoletimPage from "./pages/BoletimPage";
import ConfiguracoesPage from "./pages/ConfiguracoesPage";
import AuditoriaPage from "./pages/AuditoriaPage";
import ProdutosPage from "./pages/ProdutosPage";
import CadastrarProdutoPage from "./pages/CadastrarProdutoPage";
import DespesasPage from "./pages/DespesasPage";
import CadastrarDespesaPage from "./pages/CadastrarDespesaPage";
import ConsumoPage from "./pages/ConsumoPage";
import CadastrarConsumoPage from "./pages/CadastrarConsumoPage";
import CadastrarArtigosPage from "./pages/CadastrarArtigosPage";
import StockUniformesPage from "./pages/StockUniformesPage";
import VendasUniformesPage from "./pages/VendasUniformesPage";
import TaxasPage from "./pages/TaxasPage";
import CadastrarTaxaPage from "./pages/CadastrarTaxaPage";
import ExtrasPage from "./pages/ExtrasPage";
import CadastrarExtraPage from "./pages/CadastrarExtraPage";
import RelatorioDividasPage from "./pages/RelatorioDividasPage";
import RelatorioPagamentosPage from "./pages/RelatorioPagamentosPage";
import PagamentosEfectuadosPage from "./pages/PagamentosEfectuadosPage";
import EstudantesInactivosPage from "./pages/EstudantesInactivosPage";
import RenovacaoInscricaoPage from "./pages/RenovacaoInscricaoPage";
import ListaClassesPage from "./pages/ListaClassesPage";
import CadastrarClassePage from "./pages/CadastrarClassePage";
import RendimentoPedagogicoPage from "./pages/RendimentoPedagogicoPage";
import CadastrarProfessorPage from "./pages/CadastrarProfessorPage";
import ListaProfessoresPage from "./pages/ListaProfessoresPage";
import EditarProfessorPage from "./pages/EditarProfessorPage";
import CadastrarUtilizadorPage from "./pages/CadastrarUtilizadorPage";
import ListaUtilizadoresPage from "./pages/ListaUtilizadoresPage";
import EditarUtilizadorPage from "./pages/EditarUtilizadorPage";
import ListaPerfisPage from "./pages/ListaPerfisPage";
import CriarPerfilPage from "./pages/CriarPerfilPage";
import { isAuthenticated } from "./services/auth";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import MarcarPresencaPage from "./pages/MarcarPresencaPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";

// Screens reachable from the new sidebar menu that haven't been designed yet —
// each renders PendingScreenPage until it's tackled in its own phase.
const pendingMenuScreens = [];

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route
          exact
          path='/'
          element={
            <Navigate to={isAuthenticated() ? "/dashboard" : "/sign-in"} replace />
          }
        />
        <Route
          exact
          path='/dashboard'
          element={
            <PrivateRoute>
              <HomePageEight />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/funcionarios/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarFuncionarioPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/funcionarios/lista'
          element={
            <PrivateRoute>
              <ListaFuncionariosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/funcionarios/editar/:id'
          element={
            <PrivateRoute>
              <EditarFuncionarioPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/professores/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarProfessorPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/professores/lista'
          element={
            <PrivateRoute>
              <ListaProfessoresPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/professores/editar/:id'
          element={
            <PrivateRoute>
              <EditarProfessorPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarEstudantePage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/activos'
          element={
            <PrivateRoute>
              <ListaEstudantesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/editar/:id'
          element={
            <PrivateRoute>
              <EditarEstudantePage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/notificacoes'
          element={
            <PrivateRoute>
              <NotificacoesEstudantesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/propinas'
          element={
            <PrivateRoute>
              <ListaPropinasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/propinas/pagar/:paymentId'
          element={
            <PrivateRoute>
              <ConfirmarPagamentoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/propinas/amortizar/:studentId'
          element={
            <PrivateRoute>
              <AmortizarPagamentoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/documentos/pdf'
          element={
            <PrivateRoute>
              <PdfPreviewPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/configuracoes/multas'
          element={
            <PrivateRoute permission='configuracoes.multas'>
              <ConfiguracoesPage initialTab='multas' />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/configuracoes/pagamentos'
          element={
            <PrivateRoute permission='configuracoes.pagamentos'>
              <ConfiguracoesPage initialTab='pagamentos' />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/configuracoes/pautas'
          element={
            <PrivateRoute permission='configuracoes.pautas'>
              <ConfiguracoesPage initialTab='pautas' />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/configuracoes/auditoria'
          element={
            <PrivateRoute permission='configuracoes.auditoria'>
              <AuditoriaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/facturacao-agregada'
          element={
            <PrivateRoute>
              <FacturacaoAgregadaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/presencas'
          element={<Navigate to='/presencas/estudantes' replace />}
        />
        <Route
          exact
          path='/presencas/estudantes'
          element={
            <PrivateRoute>
              <PresencasEstudantesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/presencas/colaboradores'
          element={
            <PrivateRoute>
              <ListaPresencasColaboradoresPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/turmas/criar'
          element={
            <PrivateRoute>
              <CriarTurmaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/turmas/lista'
          element={
            <PrivateRoute>
              <ListaTurmasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/turmas/alocar-estudantes/:classId'
          element={
            <PrivateRoute>
              <AlocarEstudantesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/disciplinas'
          element={
            <PrivateRoute>
              <DisciplinasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/disciplinas/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarDisciplinaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/avaliacoes'
          element={
            <PrivateRoute>
              <AvaliacoesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/avaliacoes/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarAvaliacaoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/lancamento-notas'
          element={
            <PrivateRoute>
              <LancamentoNotasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/lista-notas'
          element={
            <PrivateRoute>
              <ListaNotasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/lista-notas/visualizar'
          element={
            <PrivateRoute>
              <PautaVisualizarPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/pautas'
          element={
            <PrivateRoute>
              <PautasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/boletim'
          element={
            <PrivateRoute>
              <BoletimPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/produtos'
          element={
            <PrivateRoute>
              <ProdutosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/produtos/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarProdutoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/lista'
          element={
            <PrivateRoute>
              <DespesasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/lista/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarDespesaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/consumo'
          element={
            <PrivateRoute>
              <ConsumoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/despesas/consumo/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarConsumoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/uniformes/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarArtigosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/uniformes/stock'
          element={
            <PrivateRoute>
              <StockUniformesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/uniformes/vendas'
          element={
            <PrivateRoute>
              <VendasUniformesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/taxas'
          element={
            <PrivateRoute>
              <TaxasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/taxas/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarTaxaPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/extras'
          element={
            <PrivateRoute>
              <ExtrasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/pagamentos/extras/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarExtraPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/relatorios/dividas'
          element={
            <PrivateRoute>
              <RelatorioDividasPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/relatorios/pagamentos'
          element={
            <PrivateRoute>
              <RelatorioPagamentosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/relatorios/pagamentos-efectuados'
          element={
            <PrivateRoute>
              <PagamentosEfectuadosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/estudantes/inactivos'
          element={
            <PrivateRoute>
              <EstudantesInactivosPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/professores/presencas'
          element={<Navigate to='/presencas/colaboradores' replace />}
        />
        <Route
          exact
          path='/estudantes/nao-inscritos'
          element={
            <PrivateRoute>
              <RenovacaoInscricaoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/classes/lista'
          element={
            <PrivateRoute>
              <ListaClassesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/classes/lista/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarClassePage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/academico/rendimento-pedagogico'
          element={
            <PrivateRoute>
              <RendimentoPedagogicoPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/utilizadores/cadastrar'
          element={
            <PrivateRoute>
              <CadastrarUtilizadorPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/utilizadores/lista'
          element={
            <PrivateRoute>
              <ListaUtilizadoresPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/utilizadores/editar/:id'
          element={
            <PrivateRoute>
              <EditarUtilizadorPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/utilizadores/perfis'
          element={
            <PrivateRoute permission='utilizadores.perfis'>
              <ListaPerfisPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/utilizadores/perfis/criar'
          element={
            <PrivateRoute permission='utilizadores.perfis'>
              <CriarPerfilPage />
            </PrivateRoute>
          }
        />
        {pendingMenuScreens.map(({ path, title }) => (
          <Route
            key={path}
            exact
            path={path}
            element={
              <PrivateRoute>
                <PendingScreenPage title={title} />
              </PrivateRoute>
            }
          />
        ))}
        <Route exact path='/index-2' element={<HomePageTwo />} />
        <Route exact path='/index-3' element={<HomePageThree />} />
        <Route exact path='/index-4' element={<HomePageFour />} />
        <Route exact path='/index-5' element={<HomePageFive />} />
        <Route exact path='/index-6' element={<HomePageSix />} />
        <Route exact path='/index-7' element={<HomePageSeven />} />
        <Route exact path='/index-8' element={<HomePageEight />} />
        <Route exact path='/index-9' element={<HomePageNine />} />
        <Route exact path='/index-10' element={<HomePageTen />} />
        <Route exact path='/index-11' element={<HomePageEleven />} />

        {/* SL */}
        <Route exact path='/add-user' element={<AddUserPage />} />
        <Route exact path='/alert' element={<AlertPage />} />
        <Route exact path='/assign-role' element={<AssignRolePage />} />
        <Route exact path='/avatar' element={<AvatarPage />} />
        <Route exact path='/badges' element={<BadgesPage />} />
        <Route exact path='/button' element={<ButtonPage />} />
        <Route exact path='/calendar-main' element={<CalendarMainPage />} />
        <Route exact path='/calendar' element={<CalendarMainPage />} />
        <Route exact path='/card' element={<CardPage />} />
        <Route exact path='/carousel' element={<CarouselPage />} />
        <Route exact path='/chat-empty' element={<ChatEmptyPage />} />
        <Route exact path='/chat-message' element={<ChatMessagePage />} />
        <Route exact path='/chat-profile' element={<ChatProfilePage />} />
        <Route exact path='/code-generator' element={<CodeGeneratorPage />} />
        <Route
          exact
          path='/code-generator-new'
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path='/colors' element={<ColorsPage />} />
        <Route exact path='/column-chart' element={<ColumnChartPage />} />
        <Route exact path='/company' element={<CompanyPage />} />
        <Route exact path='/currencies' element={<CurrenciesPage />} />
        <Route exact path='/dropdown' element={<DropdownPage />} />
        <Route exact path='/email' element={<EmailPage />} />
        <Route exact path='/faq' element={<FaqPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/marcar-presenca' element={<MarcarPresencaPage />} />
        <Route exact path='/form-layout' element={<FormLayoutPage />} />
        <Route exact path='/form-validation' element={<FormValidationPage />} />
        <Route exact path='/form' element={<FormPage />} />

        <Route exact path='/gallery' element={<GalleryPage />} />
        <Route exact path='/gallery-grid' element={<GalleryGridPage />} />
        <Route exact path='/gallery-masonry' element={<GalleryMasonryPage />} />
        <Route exact path='/gallery-hover' element={<GalleryHoverPage />} />

        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/add-blog' element={<AddBlogPage />} />

        <Route exact path='/testimonials' element={<TestimonialsPage />} />
        <Route exact path='/coming-soon' element={<ComingSoonPage />} />
        <Route exact path='/access-denied' element={<AccessDeniedPage />} />
        <Route exact path='/maintenance' element={<MaintenancePage />} />
        <Route exact path='/blank-page' element={<BlankPagePage />} />

        <Route exact path='/image-generator' element={<ImageGeneratorPage />} />
        <Route exact path='/image-upload' element={<ImageUploadPage />} />
        <Route exact path='/invoice-add' element={<InvoiceAddPage />} />
        <Route exact path='/invoice-edit' element={<InvoiceEditPage />} />
        <Route exact path='/invoice-list' element={<InvoiceListPage />} />
        <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
        <Route exact path='/kanban' element={<KanbanPage />} />
        <Route exact path='/language' element={<LanguagePage />} />
        <Route exact path='/line-chart' element={<LineChartPage />} />
        <Route exact path='/list' element={<ListPage />} />
        <Route
          exact
          path='/marketplace-details'
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path='/marketplace' element={<MarketplacePage />} />
        <Route
          exact
          path='/notification-alert'
          element={<NotificationAlertPage />}
        />
        <Route exact path='/notification' element={<NotificationPage />} />
        <Route exact path='/pagination' element={<PaginationPage />} />
        <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />
        <Route exact path='/pie-chart' element={<PieChartPage />} />
        <Route exact path='/portfolio' element={<PortfolioPage />} />
        <Route exact path='/pricing' element={<PricingPage />} />
        <Route exact path='/progress' element={<ProgressPage />} />
        <Route exact path='/radio' element={<RadioPage />} />
        <Route exact path='/role-access' element={<RoleAccessPage />} />
        <Route exact path='/sign-in' element={<SignInPage />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/star-rating' element={<StarRatingPage />} />
        <Route exact path='/starred' element={<StarredPage />} />
        <Route exact path='/switch' element={<SwitchPage />} />
        <Route exact path='/table-basic' element={<TableBasicPage />} />
        <Route exact path='/table-data' element={<TableDataPage />} />
        <Route exact path='/tabs' element={<TabsPage />} />
        <Route exact path='/tags' element={<TagsPage />} />
        <Route exact path='/terms-condition' element={<TermsConditionPage />} />
        <Route
          exact
          path='/text-generator-new'
          element={<TextGeneratorNewPage />}
        />
        <Route exact path='/text-generator' element={<TextGeneratorPage />} />
        <Route exact path='/theme' element={<ThemePage />} />
        <Route exact path='/tooltip' element={<TooltipPage />} />
        <Route exact path='/typography' element={<TypographyPage />} />
        <Route exact path='/users-grid' element={<UsersGridPage />} />
        <Route exact path='/users-list' element={<UsersListPage />} />
        <Route exact path='/view-details' element={<ViewDetailsPage />} />
        <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
        <Route exact path='/videos' element={<VideosPage />} />
        <Route exact path='/view-profile' element={<ViewProfilePage />} />
        <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
        <Route exact path='/wallet' element={<WalletPage />} />
        <Route exact path='/widgets' element={<WidgetsPage />} />
        <Route exact path='/wizard' element={<WizardPage />} />

        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
